<template>
  <div v-if="list && list.length" class="homeWrap mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">客户案例</div>
      <div class="text2">不端提高的高质量交付服务，等你体验</div>
    </div>
    <div class="slider-container exampleWrap">
      <div class="slider-wrapper" ref="sliderWrapper">
        <div class="slider-content" :style="{ transform: `translateX(-${currentIndex * 25}%)` }">
          <div class="exampleItem" v-for="(item, index) in list" :key="index"
            @click="navTo('/customerCaseDetail', { id: item.id })">
            <OssImg class="exampleImg mariaNoShadow" :src="item.caseOssUrl" style="width: 100%" />
            <div class="exampleItemInfo">
              <div class="ellipsis">{{ item.caseTitle }}</div>
              <div class="ellipsis-multiline" style="-webkit-line-clamp: 2;">{{ item.caseRemark }}</div>
            </div>
          </div>
        </div>
      </div>
      <NavButton v-if="list.length > 4" v-model="currentIndex" :listLength="list.length"></NavButton>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import NavButton from "@/components/navButton.vue";
import { navTo } from '@/utils/util';
import CaseApi from "@/api/caseApi";
const caseApi = new CaseApi();

//客户案例
const list = ref([]);
const currentIndex = ref(0);

onMounted(() => {
  getList()
})

//获取案例列表
const getList = async () => {
  let res = await caseApi.getCaseList()
  list.value = res || []
}
</script>

<style lang="scss" scoped>
.exampleWrap {
  width: 100%;

  .slider-wrapper {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
  }

  .slider-content {
    display: flex;
    transition: transform 0.3s ease;
  }

  .exampleItem {
    flex: 0 0 calc(25% - 1.5rem);
    height: 21.125rem;
    margin: 0 0.75rem;
    border-radius: 1rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .exampleImg {
      width: 100%;
      height: 13.75rem;
      object-fit: contain;
      border-radius: 1rem 1rem 0 0;
    }

    .exampleItemInfo {
      width: 100%;
      flex-grow: 1;
      padding: 1rem;
      box-sizing: border-box;
      text-align: justify;
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 500;

      >div {
        margin-bottom: 1rem;
      }
    }
  }
}

// @media(max-width: 768px) {
//   .slider-content {
//     flex-wrap: wrap;
//   }

//   .exampleItem {
//     flex: 0 0 calc(50% - 1.5rem) !important;
//     margin-bottom: 1rem !important;
//   }
// }</style>
